import { z } from 'zod'

export const ADMINPUBLICPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminPublicPostResponseSchema = z.unknown()
export type AdminPublicPostResponse = z.infer<typeof adminPublicPostResponseSchema>
